import {
    FieldInstruction,
    FieldInstructionBundle,
} from 'containers/FormBuilder'
import CurrencyAmountField from 'form/fieldComponents/CurrencyAmountField'
import InputField from 'form/fieldComponents/InputField'
import SelectField from 'form/fieldComponents/SelectField'
import { FIELD_REQUIRED } from 'form/validation/validationMessages'
import RvType from 'state/enums/RvType'
import * as Yup from 'yup'

const model: FieldInstruction<typeof InputField> = {
    Component: InputField,
    config: {
        label: 'Model Name',
        validator: Yup.string().required(FIELD_REQUIRED),
    },
}

const rvType: FieldInstruction<typeof SelectField> = {
    Component: SelectField,
    config: {
        label: 'Vehicle Type',
        options: Object.entries(RvType).map(([, name]) => ({
            name,
            value: name,
        })),
        placeholder: 'Vehicle Type',
        validator: Yup.string().required(FIELD_REQUIRED),
    },
}

export const makeFieldInstructionBundle = (
    assetValueLabel: string,
    assetValueHelpText?: string,
) =>
    ({
        rvType,
        model,
        assetValue: {
            Component: CurrencyAmountField,
            config: {
                helpText: assetValueHelpText,
                label: assetValueLabel,
                validator: Yup.string().required(FIELD_REQUIRED),
            },
        } as FieldInstruction<typeof CurrencyAmountField>,
    }) as FieldInstructionBundle
